export function getStackTrace(): string[] {
  let stackTrace;
  try {
    throw new Error('');
  } catch (error: any) {
    stackTrace = error.stack || '';
  }

  stackTrace = stackTrace.split("\n").map(line => line.trim());
  return stackTrace.splice(stackTrace[0] === 'Error' ? 2 : 1);
};

export const logRocketError = (message: string) => {
  // I wanted to put a stack trace in the message itself, but we already know which file its in, because
  // that's implicit based the message we get. So the line number, and elements higher up the call stack is
  // would be useful, but getting a stack trace is complicated (yay web dev), and the code is minified so the
  // line number is wrong. We'll just console.trace() and look at the console in logrocket instead.
  console.trace(message);

  if (window.LogRocket) {
    window.LogRocket?.captureMessage(message);
  }
};